import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BuilderTabs from "../../Layouts/BuilderTabs";
import Loader from "../../Layouts/Loader/Loader";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import SearchQuery from "../../components/BuilderComponents/SearchQuery";

import Button from "../../components/FormComponents/Button";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import { useAuth0Context } from "../../context/Auth0Context";
import { useModalContext } from "../../context/ModalContext";
import BlackAndWhiteTheme from "../../images/BlackAndWhiteTheme.png";
import BlueLabelTheme from "../../images/BlueLabelTheme.png";
import BlueNewTheme from "../../images/BlueNewTheme.png";
import CherryRedTheme from "../../images/CherryRedTheme.png";
import GradientTheme from "../../images/GradientTheme.png";
import GreyTheme from "../../images/GreyTheme.png";
import MorphTheme from "../../images/MorphTheme.png";
import NewDarkTheme from "../../images/NewDarkTheme.png";
import OrangeTheme from "../../images/OrangeTheme.png";
import SAPtheme from "../../images/SAPtheme.png";
import StandardTheme from "../../images/StandardTheme.png";
import NandiPostSaleTheme from "../../images/NandiPostSaleTheme.png";
import MaroonTheme from "../../images/MaroonTheme.png";
import NewTheme from "../../images/NewTheme.png";
import OceanBlueTheme from "../../images/OceanBlueTheme.png";
import "./Theme.css";
import AddTheme from "./AddTheme";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";

const themeAccessOnly = ["admin", "super-admin"];
const ThemeSection = () => {
  const params = useParams();
  const [themes, setThemes] = useState([]);
  const [addClick, setAddClick] = useState(false);
  // const [iframeOpen, setIframeOpen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredThemes, setFilteredThemes] = useState(themes);
  const { getUserConfirmationForDelete } = useModalContext();
  const { user } = useAuth0Context();
  const userCanDoActionOnTheme = user.role_names.some((role) => themeAccessOnly.includes(role));
  const [deviceFilter, setDeviceFilter] = useState("desktop");
  const navigate = useNavigate();

  const getThemes = async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(`/screentheme/sysconfigs/type/theme`);
      setThemes(data);
      setIsLoading(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  // edit theme
  const handleUpdateTheme = (e, theme) => {
    e.stopPropagation();
    navigate(`/theme/${theme.id}`);
  };

  // delete theme
  const handleDeleteTheme = async (e, id, name) => {
    e.stopPropagation();
    try {
      const userConfirmed = await getUserConfirmationForDelete(name, "app");
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/screentheme/sysconfigs/${id}`);
      // setIsModalOpen("");
      setThemes((prevThemes) => prevThemes.filter((themeList) => themeList.id !== id));
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const mobileThemes = filteredThemes.filter((theme) => theme.config.device === "mobile");
  const desktopThemes = filteredThemes.filter((theme) => theme.config.device === "desktop");
  const tabletThemes = filteredThemes.filter((theme) => theme.config.device === "tablet");

  const sortThemesAlphabetically = (themes) => {
    return [...themes].sort((a, b) => a.name.localeCompare(b.name));
  };
  const renderThemes = (themes, deviceType, handleUpdateTheme, handleDeleteTheme) => {
    const filteredThemes = themes.filter((theme) => theme.config.device === deviceType);

    return filteredThemes.length > 0 ? (
      sortThemesAlphabetically(filteredThemes).map((theme) => (
        <ThemeCard
          key={theme.id}
          theme={theme}
          handleUpdateTheme={handleUpdateTheme}
          handleDeleteTheme={handleDeleteTheme}
          userCanDoActionOnTheme={userCanDoActionOnTheme}
        />
      ))
    ) : (
      <NoThemeFound />
    );
  };

  const allTabs = [
    {
      label: "Public Desktop",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(desktopThemes, "desktop", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    },
    {
      label: "Public Mobile",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(mobileThemes, "mobile", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    },
    {
      label: "Public Tablet",
      content: (
        <div className="theme_iframe_container">
          {renderThemes(tabletThemes, "tablet", handleUpdateTheme, handleDeleteTheme)}
        </div>
      )
    }
  ];

  const handleTabChange = (label) => {
    setDeviceFilter(label.toLowerCase());
  };

  return (
    <div className="application_container">
      <AppLeftSideBar type={params.orgId ? "app" : "org"} />
      <div className="page_section">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="dashboard_outer_section">
            <div className="dashboard-top-header">
              <h2>Themes</h2>
              <div className="d_flex align_center gap_1">
                <SearchQuery
                  data={themes || []}
                  searchKey="name"
                  onSearch={setFilteredThemes}
                  placeholder="Search Themes"
                />
                <Button
                  type="add"
                  variant="primary"
                  size="medium"
                  onClick={() => setAddClick(true)}
                  style={{ height: "36px" }}
                >
                  <MaterialIcon name="add" style={{ fontSize: "20px", marginRight: "6px" }} />
                  New Theme
                </Button>
              </div>
            </div>
            <div className="org-dashboard-page-body flex_column g_5 overflow_hidden">
              <BuilderTabs
                tabs={allTabs}
                containerClass="themes_tabs"
                contentClass="h_100 w_100 overflow_auto"
                onChange={handleTabChange}
              />
            </div>
          </div>
        )}
      </div>

      <BuilderModal isOpen={addClick} onClose={() => setAddClick(false)} modalName="Add Theme">
        <AddTheme setThemes={setThemes} onClose={() => setAddClick(false)} deviceFilter={deviceFilter} from="auth" />
      </BuilderModal>
    </div>
  );
};
const ThemeCard = ({ theme, handleUpdateTheme, handleDeleteTheme, userCanDoActionOnTheme }) => (
  <div key={theme.id} className="theme_card">
    <div className="theme_image">
      <div className="theme_actions">
        {userCanDoActionOnTheme && (
          <div className="d_flex gap_2">
            <MaterialIcon name="edit" className="builder_action_btn" onClick={(e) => handleUpdateTheme(e, theme)} />
            <MaterialIcon
              name="delete"
              className="builder_action_btn"
              onClick={(e) => handleDeleteTheme(e, theme.id, theme.name)}
            />
          </div>
        )}
        {!userCanDoActionOnTheme && (
          <div className="d_flex gap_2">
            <MaterialIcon
              name="visibility"
              className="builder_action_btn"
              onClick={(e) => handleUpdateTheme(e, theme)}
            />
          </div>
        )}
      </div>
      <div className="theme_name">
        <label className="theme_label">{theme.name}</label>
        {theme.org_id && <label className="builder_label">{`(${theme.org_name})`}</label>}
      </div>
      <hr className="light-line"></hr>
      <div className="overlay_cover"></div>
      <img src={getThemeImage(theme.name)} alt={theme.name} className="theme_image" />
    </div>
  </div>
);
export const getThemeImage = (name) => {
  switch (name) {
    case "Standard":
      return StandardTheme;
    case "Morph Theme":
      return MorphTheme;
    case "New Dark":
      return NewDarkTheme;
    case "cherry red":
      return CherryRedTheme;
    case "Black and white":
      return BlackAndWhiteTheme;
    case "Blue Label":
      return BlueLabelTheme;
    case "Sap":
      return SAPtheme;
    case "Sap Inline Label":
      return SAPtheme;
    case "Blue new theme":
      return BlueNewTheme;
    case "Gradient":
      return GradientTheme;
    case "Grey":
      return GreyTheme;
    case "Orange Theme (build x)":
      return OrangeTheme;
    case "Blue Label Mobile":
      return BlueLabelTheme;
    case "Orange Theme":
      return OrangeTheme;
    case "Blue New":
      return BlueNewTheme;
    case "Dark Purple":
      return NewDarkTheme;
    case "Mobile Dark":
      return BlackAndWhiteTheme;
    case "Purple Theme":
      return GreyTheme;
    case "Z - Nandi Post Sale":
      return NandiPostSaleTheme;
    case "Z - Maroon":
      return MaroonTheme;
    case "Z-New":
      return NewTheme;
    case "Z - ocean-blue":
      return OceanBlueTheme;
    default:
      return "";
  }
};

const NoThemeFound = () => {
  return (
    <div style={{ gridColumn: "-1/1" }}>
      <p style={{ fontWeight: "500", fontSize: "24px", textAlign: "center", width: "100%" }}>No Theme Found</p>
    </div>
  );
};

export default ThemeSection;
export { ThemeCard, NoThemeFound };
